const today = new Date();
const curYear = today.getFullYear().toString().slice(-2);
const curMonth = today.getMonth() + 1;

export const invalidIdMessage =
  'Only lowercase letters, numbers, single dashes and single underscores are allowed and first character should be a letter';

export const isDateInPast = (value: string) => {
  return (customMessage = 'Expiry year cannot be in the past') => {
    if ((value as string).length === 5) {
      const month = value.split('/')[0];
      const year = value.split('/')[1];
      return year > curYear || (year === curYear && +month >= curMonth) ? '' : customMessage;
    }
    return '';
  };
};

export const validateUserId = (value: string, customMessage = invalidIdMessage): string => {
  return /^[a-z][\d_a-z-]*$/.test(value as string) && !/(-)\1/.test(value as string) && !/(_)\1/.test(value as string) ? '' : customMessage;
};

export const emailRegex =
  /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z-]+\.)+[A-Za-z]{2,}))$/;
